<template>
  <article class="front-art">
    <ul class="tab-service-detail borT-none">
      <li v-for="item in tabList" :class="{'on': item.key === type, 'flexnum': item.moreFlex}" :key="item.key" @click.stop="onShiftTap(item.key)">
        <a href="javascript:void(0);" :class="{'not_completed': !info[item.key]}">{{item.title}}</a>
      </li>
    </ul>
    <group>
      <cell v-for="(check, index) in checkList" is-link :title="check.title.join(',')" :class="{colorRed:color(check)}" class="fs30" :key="index" @click.native="handlerOpenDialog(check)">
        <span slot="icon">{{check.note}}</span>
      </cell>
    </group>

    <x-dialog v-model="show" class="dialog-demo" @on-hide="cancel">
      <span class="vux-close-box" @click.stop="cancel()"><span class="vux-close"></span></span>
      <div class="pl">
        <p class="title-check">{{finishImgInfo.note}}</p>
        <checker v-model="demo1Checkbox" type="checkbox" default-item-class="checkbox-item">
          <checker-item v-for="(target,index) in finishImgInfo.damageList" :value="target.key" @click.native.stop.prevent="selectCheckbox(target)" :key="index" :class="{'singleLine':index===0||index===finishImgInfo.damageList.length-1,'checkbox-item-selected':target.selected}">
            {{target.value}}
          </checker-item>
        </checker>
        <input v-show="showRemark" type="text" v-model="finishImgInfo.message" class="inp-bo" placeholder="请输入问题描述(必填)">
        <div class="choice-pic-list" v-if="showPhotoUpload">
          <upload-pic
            :images.sync="uploadImgList"
            :show-name="uploadImg.showName"
            :dragable="uploadImg.dragable"
            :count="uploadImg.length"
            @upload="ImgUpload"
            @delete="ImgDelete">
            <p class="title">{{uploadImg.title}}</p>
          </upload-pic>
        </div>
      </div>
      <div class="btn-top">
        <x-button value="确定" class="btn" type="primary" @click.native="confirm()">确定</x-button>
      </div>
    </x-dialog>
    <footer-btn :title="btnName" @submit="toSave()"></footer-btn>
  </article>
</template>
<script>
// 检查信息（车头）
import { XButton, Cell, Group, XDialog, Checker, CheckerItem, UploadPic } from '@lx-frontend/cvux'
import FooterBtn from '../../components/FooterBtn'
import check from './check'
import cache from '../../../common/cache'
import { inspection as inspectionUrl } from './restConfig'

export default {
  components: {
    XButton,
    Cell,
    Group,
    XDialog,
    Checker,
    CheckerItem,
    FooterBtn,
    UploadPic
  },
  data() {
    return {
      finishImgInfo: {
        images: []
      },
      uploadImgInfo: [],
      uploadImgList: [],
      uploadImg: {
        showName: false,
        dragable: false,
        requestUrl: 'getImageByAuctionInBatch',
        title: '请上传故障点照片（必传）',
        length: 16
      },
      id: '',
      type: 'head',
      info: {},
      checkList: [],
      show: false,
      showRemark: false,
      showPhotoUpload: false,
      demo1Checkbox: [2, 1],
      tabList: [{
        title: '车头',
        key: 'head'
      }, {
        title: '左侧',
        key: 'left'
      }, {
        title: '车尾',
        key: 'tail'
      }, {
        title: '右侧',
        key: 'right'
      }, {
        title: '机械内饰',
        key: 'machine_interior',
        moreFlex: true
      }, {
        title: '电器',
        key: 'appliance'
      }],
      temporaryItem: '',
      source: '' // 页面访问来源
    }
  },
  created() {
    this.initData()
  },
  computed: {
    btnName() {
      let item = this.tabList.find(v => {
        return v.key === this.type
      })
      return `保存${item.title}检测`
    }
  },
  watch: {
    uploadImgList: {
      handler(arr) {
        this.uploadImgInfo = []
        arr.forEach(item => {
          this.uploadImgInfo.push(item.src)
        })
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    getListData(list) {
      if (list) {
        list.forEach((v) => {
          let index = this.checkList.findIndex((t) => {
            return v.id === t.id
          })
          if (index >= 0) {
            Object.assign(this.checkList[index], {
              'id': v.id,
              'title': v.title,
              'images': v.images || [],
              'message': v.message || ''
            })
            this.filterDamageList(v.damageList, this.checkList[index].damageList)
          }
        })
      }
    },
    initData() {
      this.source = this.$route.params.source
      let auctionId = this.id = this.$route.params.id
      if (auctionId) {
        this.checkList = JSON.parse(JSON.stringify(check.auctionCheckModeList[this.type]))
        let url = inspectionUrl.getInspectionsInfo[this.source](this.id)
        this.$rest.carInfo.query(null, url).then((res) => {
          if (res.code === 0) {
            this.info = res.data.inspection
            let subCheckList = this.info[this.type]
            this.getListData(subCheckList)
          }
        })
      }
    },
    filterDamageList(list, list2) {
      list.forEach(x => {
        let index = list2.findIndex(y => x.key === y.key)
        if (index !== -1) {
          Object.assign(list2[index], {
            selected: x.selected
          })
        }
      })
    },
    onShiftTap(mark) {
      if (this.type === mark) return false
      this.toSave(mark)
    },
    color(item) {
      let len = item.damageList.filter(v => {
        return v.key !== '1' && v.selected
      })
      return len.length > 0
    },
    handlerOpenDialog(item) {
      // 初始化弹框
      this.finishImgInfo = item
      // 临时缓存条目
      this.temporaryItem = JSON.stringify(item)

      // 图片
      this.uploadImgInfo = item.images
      this.uploadImgList = []
      item.images.forEach(item => {
        let obj = { src: item, name: '其他', code: 'other' }
        this.uploadImgList.push(obj)
      })

      // 是否有损伤
      let hasDamage = this.showPhotoUpload = this.finishImgInfo.damageList.some(v => v.selected && v.value !== '正常')
      if (!hasDamage) {
        this.finishImgInfo.damageList[0].selected = true
      }
      // 是否有`其他`损伤
      this.showRemark = !!item.message

      this.show = true
    },
    resetDamageItem(item) {
      // 清理图片
      // 如果提交时选择的是正常，但是之前有选择异常项且上传了图片，清理图片
      let hasDamage = item.damageList.some(v => v.value !== '正常' && v.selected)

      let hasImage = item.images.length > 0
      if (!hasDamage && hasImage) {
        item.images = []
      }

      // 清理其他选项时的文案
      let hasOther = item.damageList.some(v => v.value === '其他' && v.selected)
      if (!hasOther && item.message) {
        item.message = ''
      }
    },
    confirm() {
      if (this.showRemark && !this.finishImgInfo.message) {
        this.showToast('请输入问题描述')
        return false
      }
      this.finishImgInfo.images = this.uploadImgInfo
      // fix-sentry: https://sentry.lixinio.com/lixin/dos-qiye-frontend/issues/2892
      let upLoaded = (this.uploadImgInfo || []).some(v => !!v)
      if (this.showPhotoUpload && !upLoaded) {
        this.showToast('请上传照片')
        return false
      }
      this.resetDamageItem(this.finishImgInfo)
      this.show = false
      this.itemTitle()
      this.finishImgInfo = []
      this.temporaryItem = ''
    },
    cancel() {
      if (this.temporaryItem) {
        this.finishImgInfo = JSON.parse(this.temporaryItem)
        let index = this.checkList.findIndex(v => v.id === this.finishImgInfo.id)
        this.checkList[index] = this.finishImgInfo
        this.show = false
        this.showPhotoUpload = false
        this.showRemark = false
      }
    },
    selectCheckbox(target) {
      let len = this.finishImgInfo.damageList.length
      let index = this.finishImgInfo.damageList.findIndex((v) => {
        return v.key === target.key
      })
      if (index === 0) {
        this.finishImgInfo.damageList.forEach(v => {
          let selected = false
          if (v.key === '1') {
            selected = !v.selected
          }
          v.selected = selected
          this.showRemark = false
        })
      } else if (index > 0 && index < len - 1) {
        this.finishImgInfo.damageList[0].selected = false
        this.finishImgInfo.damageList[index].selected = !target.selected
      } else if (index === len - 1) {
        this.finishImgInfo.damageList[0].selected = false
        this.showRemark = this.finishImgInfo.damageList[len - 1].selected = !target.selected
        let exceptArr = [62, 63, 64, 65, 66, 67, 68, 69]
        if (exceptArr.includes(this.finishImgInfo.id)) {
          this.showRemark = false
        }
      }
      let damageItems = this.finishImgInfo.damageList.filter(v => {
        return v.selected && v.key !== '1'
      })
      this.showPhotoUpload = damageItems.length > 0
      this.itemTitle()
    },
    itemTitle() {
      let firstItem = this.finishImgInfo.damageList.filter(v => {
        return v.key === '1' && v.selected
      })
      if (!firstItem.length) {
        let set = new Set([])
        this.finishImgInfo.damageList.forEach((v) => {
          if (v.selected) {
            set.add(v.value)
          }
        })
        let result = this.finishImgInfo.title = [...set]
        if (result.length === 0) {
          this.finishImgInfo.title = this.finishImgInfo.defaultTitle
        }
      } else {
        this.finishImgInfo.title = this.finishImgInfo.defaultTitle
      }
    },
    toSave(nextpage) {
      let inspections = {}
      let apart = inspections[this.type] = []
      this.checkList.forEach((v) => {
        let filterArray = v.damageList.filter((t) => {
          return t.selected && t.key !== '-1'
        })
        let obj = {
          id: v.id,
          title: v.title,
          damageList: [],
          note: v.note
        }
        // 如果做出了选择.就把选择项添加上去.
        if (filterArray.length) {
          obj.damageList = filterArray
          obj.images = v.images
          obj.message = v.message
        } else {
          // 如果没有做出选择,就添加第一项(默认项),并且第一项 selected=true
          let firstItem = v.damageList.find(x => {
            return x.key === '1'
          })
          firstItem.selected = true
          obj.damageList.push(firstItem)
        }
        apart.push(obj)
      })
      let url = inspectionUrl.saveInspectionsInfo[this.source](this.id)
      this.$rest.carInfo.create({
        inspection: JSON.stringify(inspections)
      }, url).then((res) => {
        if (res.code === 0) {
          if (nextpage) { // 切换页签
            this.type = nextpage
          } else { // 点击底部按钮
            let index = this.tabList.findIndex(v => {
              return v.key === this.type
            })
            let lastIndex = this.tabList.length - 1
            if (index === lastIndex) { // 最后一项点击保存，则返回上一页
              let ticketId = cache.getSessionData('CAR_INFO_TICKET_ID') || ''
              let query = ticketId && `?ticketId=${ticketId}`
              this.$router.push(`/auction/carInfo/edit/${this.id}/${this.source}${query}`)
              return false
            } else {
              this.type = this.tabList[index + 1].key
            }
          }
          this.info = res.data.inspection
          this.checkList = JSON.parse(JSON.stringify(check.auctionCheckModeList[this.type]))
          let subCheckList = this.info[this.type]
          this.getListData(subCheckList)
          this.showToast('保存成功')
        } else {
          this.showToast(res.message)
        }
      })
    },
    ImgUpload(i) {
      let iamges = this.uploadImgList
      this.$wechat.batchImgUpload(this, i, iamges, this.uploadImg.requestUrl, this.uploadImg.length)
    },
    ImgDelete(i) {
      let iamges = this.uploadImgList
      this.$wechat.imgDelete(i, iamges)
    }
  }
}

</script>
<style rel="stylesheet/less" lang="less">
@import "../../../stylesheets/modules/manage/checklist.less";
.front-art{
  .tab-service-detail{
    .flexnum{
      flex: 1.5;
    }
    .not_completed {
    position: relative;
      &:after{
        content: "";
        position: absolute;
        top: 15/@w2;
        right: -15/@w2;
        width: 12/@w2;
        height: 12/@w2;
        background-color: #fb3f3f;
        .radius(50%);
      }
    }
  }
}

.fs30 {
  .weui_cell_hd span {
    font-size: 30/@w2;
  }
}

.singleLine {
  display: block;
}

.front-art {
  .vux-close-box {
    position: absolute;
    top: 50/@w2;
    right: 30/@w2;
    width: 40/@w2;
    height: 40/@w2;
    text-align: right;
    z-index: 99;
  }
  .vux-close {
    display: inline-block;
    vertical-align: middle;
    width: 36/@w2;
    height: 36/@w2;
    overflow: hidden;
    color: #ccc;
    &:before,
    &:after {
      content: "";
      position: absolute;
      height: 1px;
      width: 100%;
      top: 50%;
      left: 0;
      background: #98979d;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }
}

</style>
